import React from 'react';

import ColumnDropdownSelector from 'data-frames/column-selector/ColumnDropdownSelector';
import {GetPipelineConfigSpecType} from 'pipelines/StepShapeUtils';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import {ButtonSize} from 'ui-library/buttons/Button';
import {CornerRadius} from 'ui-library/dropdowns/SelectDropdown';

import {useStepConfigEditorContext} from '../StepConfigEditorContext';

interface ColumnReferenceProps {
  config: string | null;
  onChangeConfig: (config: string | null) => void;
  configShape: GetPipelineConfigSpecType<'columnReference'>;
  dataTestAttrs?: DataTestAttrs;
  disabled?: boolean;
  buttonSize?: ButtonSize;
  cornerRadius?: CornerRadius;
  noColumnSelectedText?: string;
  allowSelectNull?: boolean;
}

export default function ColumnReferenceEditor({
  config,
  onChangeConfig,
  configShape,
  dataTestAttrs,
  disabled,
  cornerRadius,
  buttonSize = ButtonSize.MEDIUM,
  noColumnSelectedText = 'Select column',
  allowSelectNull = false,
}: ColumnReferenceProps): JSX.Element {
  const {dataFrameSpec} = useStepConfigEditorContext();
  return (
    <ColumnDropdownSelector
      dataFrameSpec={dataFrameSpec}
      dataTestAttrs={dataTestAttrs}
      onChange={onChangeConfig}
      selectedColumnSystemName={config}
      validationOptions={configShape.validationOptions ?? undefined}
      buttonSize={buttonSize}
      noColumnSelectedText={noColumnSelectedText}
      allowSelectNull={allowSelectNull}
      disabled={disabled}
      cornerRadius={cornerRadius}
    />
  );
}
